// Inyecta settings.json antes de arrancar la app
// Carga el settings.json y lo expone en window.__env

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

const SETTINGS_URL = 'assets/settings.json';

function loadSettings(): Promise<any> {
  return fetch(SETTINGS_URL, { cache: 'no-store' })
    .then(resp => {
      if (!resp.ok) {
        console.warn('Could not load settings.json, using defaults', resp.status);
        return {};
      }
      return resp.json();
    })
    .then(cfg => {
      // exponemos en window para que el resto de la app lo lea
      (window as any).__env = cfg || {};
    })
    .catch(err => {
      console.warn('Error loading settings.json, using defaults', err);
      (window as any).__env = {};
    });
}

if (environment.production) {
  enableProdMode();
}

loadSettings().then(() => {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
});

// platformBrowserDynamic().bootstrapModule(AppModule)
//   .catch(err => console.error(err));
